import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import page1 from "../../docs/page1_v2.png";
import page2 from "../../docs/page2_v2.png";
import styles from "./ProductsPageClient.module.scss";

export const HelpPage = () => {
    return (
        <Container className="p-4 pageMaxWidthClient">
            <Row>
                <Col xs={12} className="text-subtle mt-1 text-center">
                    <div
                        className="d-inline-block text-subtle text-start"
                        style={{ width: "100%", maxWidth: 1280 }}
                    >
                        <h2 className={styles.listTitle}>Guides</h2>
                        <p>
                            See instructions also in{" "}
                            <a
                                href="https://doc.clickup.com/20449045/p/h/kg1rn-70052/c4ceddda80d6109"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Clickup
                            </a>
                            .
                        </p>
                    </div>
                </Col>
            </Row>
            <Row className="g-4 mt-1">
                <Col xs={12} className="text-center">
                    <img
                        src={page1}
                        alt="Instructions"
                        style={{
                            maxWidth: 1280,
                            width: "100%",
                            height: "auto",
                            borderRadius: 8
                        }}
                    />
                </Col>
                <Col xs={12} className="text-center">
                    <img
                        src={page2}
                        alt="Instructions"
                        style={{
                            maxWidth: 1280,
                            width: "100%",
                            height: "auto",
                            borderRadius: 8
                        }}
                    />
                </Col>
            </Row>
        </Container>
    );
};
